export const normalizePriceInput = (value: string) => {
  const sanitized = value.replace(/[^\d,]/g, '').replace(/^,+/, '');
  const [integerPart = '', ...fractionParts] = sanitized.split(',');

  if (!fractionParts.length) {
    return integerPart;
  }

  const fractionPart = fractionParts.join('').slice(0, 2);
  return `${integerPart},${fractionPart}`;
};
